import {NotificationToastService} from '../../services/notification-toast/notification-toast.service';
import { Subscription } from "rxjs";
import { Utente } from "src/app/model/utente/utente";
import { AppUtilsService } from "../services/app-utils.service";
import { SnackBarAndSpinnerComponent } from "./SnackBarAndSpinnerComponent";

export abstract class PageContainerComponent extends SnackBarAndSpinnerComponent {

    utenteLoggato: Utente;

    obsIsTeamView: Subscription;
    isTeamView = false;

    constructor(
        protected appUtils: AppUtilsService,
        protected snackBar: NotificationToastService) { 
        super(snackBar)
    }

    checkTeamView(){
        this.obsIsTeamView = this.appUtils.getIsTeamView().subscribe((value) => {
            this.isTeamView = value;
            this.onViewChange();
        });
    }

    abstract onViewChange();
    // metodo messo per ricordare di fare l'unsubscribe nell' onDestory
    abstract unsubscribeOnDestroy();

}
